// extracted by mini-css-extract-plugin
export default {"options":"AsideElementLearn_options__0uexz","text":"AsideElementLearn_text__4DxL+"};